import {CaesarsButton} from '@eCommerce/frontend-legacy-shared-library-native';
import {useNavigation} from '@react-navigation/native';
import {Box, Button, Pressable, Text, View} from 'native-base';
import React from 'react';
import {Platform} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import Icon from 'react-native-vector-icons/FontAwesome5Pro';

import {Routes} from 'models/Navigation';

import {FCC} from '../../../types';

interface FilterScreenMobileProps {
  title: string;
}

const FilterScreenMobile: FCC<FilterScreenMobileProps> = ({
  children,
  title,
}) => {
  const isWeb = Platform.OS === 'web';
  const isIOS = Platform.OS === 'ios';
  const navigation = useNavigation();
  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.navigate(Routes.Offers.Filters);
    }
  };
  return (
    <Box width={'100%'} height={'100%'} bgColor={'white'}>
      <View
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        style={{
          paddingTop: isIOS ? 32 : undefined,
          flex: 1,
          maxHeight: isWeb ? '100vh' : undefined,
          backgroundColor: 'white',
        }}>
        <View
          borderBottomWidth={2}
          borderBottomColor="athens"
          flexDirection="row"
          alignItems="center"
          height={'90px'}>
          <Pressable accessibilityLabel="Back Button" ml={6} onPress={goBack}>
            <Icon name="arrow-left" size={30} />
          </Pressable>
          <View mr={8} alignItems="center" flex={1}>
            <Text fontSize={5} fontWeight={700}>
              {title}
            </Text>
          </View>
        </View>
        <View style={{flex: 1}}>{children}</View>
        {title !== 'DESTINATION' && (
          <View shadow={5} p={4} backgroundColor="white">
            <CaesarsButton
              isFullWidth={true}
              title="Add Filters"
              onPress={() => navigation.navigate(Routes.Offers.Filters)}
            />
          </View>
        )}
      </View>
    </Box>
  );
};

export default FilterScreenMobile;
